import {imageHardSize} from '../helpers/FuckIE';

;$(function() {
	if (! fuckIE) return;

	imageHardSize($('body'));
});